import { PriceIndividualView } from ".";

export class PriceConditionView {
    public priceConditionId: string;
    public referencePriceConditionId: string;
    public conditionCode: string;
    public numberOfUnits: number;
    public statusCode: string = 'A';
    public individuals = new Array<PriceIndividualView>();
}